import { render, staticRenderFns } from "./EditAjustesDest.vue?vue&type=template&id=c4963ada"
import script from "./EditAjustesDest.vue?vue&type=script&lang=js"
export * from "./EditAjustesDest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports